import { z } from 'zod';
import { EVIDENCE_TYPES, NAME_CHANGE_REASONS, REQUESTER_TYPES } from '../types/customers.types';

const required = (message: string) => ({ required_error: message, invalid_type_error: message });

// Mirrors ChangeCustomerNameRequest field for field. Evidence is required for
// every requester, the dealer included, so there is no conditional refinement.
export const customerNameChangeSchema = z.object({
    title: z.string(required('Title is required')).trim().min(1, 'Title is required').max(10),
    forename: z.string(required('Forename is required')).trim().min(1, 'Forename is required').max(255),
    surname: z.string(required('Surname is required')).trim().min(1, 'Surname is required').max(255),
    reason: z.enum(NAME_CHANGE_REASONS, { errorMap: () => ({ message: 'A reason is required' }) }),
    requesterType: z.enum(REQUESTER_TYPES, {
        errorMap: () => ({ message: 'Select who requested the change' }),
    }),
    evidenceType: z.enum(EVIDENCE_TYPES, { errorMap: () => ({ message: 'Evidence is required' }) }),
});

export type CustomerNameChangeFormInputs = z.infer<typeof customerNameChangeSchema>;
